module.exports = __webpack_public_path__ + "img/mallgoods.abae2143.jpg";